module.exports = __webpack_public_path__ + "static/img/loding…….50ae80e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/loding…….gif
// module id = mViw
// module chunks = 104